module.exports = __webpack_public_path__ + "img/menu_comm_inactive.d06def8.png";